import React from 'react';
import './spinner.css';

const Spinner = ({ 
    size = 'medium', 
    color = 'primary', 
    text = 'Cargando...', 
    showText = true,
    variant = 'rings', // 'rings', 'dots', 'pulse', 'bars'
    className = '' 
}) => {
    const renderSpinner = () => {
        switch (variant) {
            case 'dots':
                return (
                    <div className={`spinner-dots ${size} ${color}`}>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </div>
                );
            case 'pulse':
                return (
                    <div className={`spinner-pulse ${size} ${color}`}></div>
                );
            case 'bars':
                return (
                    <div className={`spinner-bars ${size} ${color}`}>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                );
            default: // rings
                return (
                    <div className={`spinner-rings ${size} ${color}`}>
                        <div className="ring"></div>
                        <div className="ring"></div>
                        <div className="ring"></div>
                    </div>
                );
        }
    };

    return (
        <div className={`spinner-container ${className}`}>
            {renderSpinner()}
            {showText && text && (
                <p className="spinner-text">{text}</p>
            )}
        </div>
    );
};

export default Spinner;
